import axios from "axios";

export enum CommentFor {
  CONTACT = "CONTACT",
  EMAIL = "EMAIL",
  PROJECT = "PROJECT",
}

export interface Comment {
  id: string | null;
  createdBy: string;
  created: Date;
  updated: Date | null;
  content: string;
  answers: Comment[];
  commentFor: CommentFor;
  upstreamRef?: string;
}

interface CommentApi {
  listForUpstream(upstreamRef: string): Promise<Comment[]>;
  countCommentsForUpstream(upstreamRef: string): Promise<number>;
  getById(id: string): Promise<Comment>;

  addCommentForUpstream(upstreamRef: string, comment: Comment): Promise<string>;

  edit(comment: Comment): Promise<void>;

  delete(comment: Comment): Promise<void>;

  addAnswer(comment: Comment, answer: Comment): Promise<void>;
}

export const commentApi: CommentApi = {
  async listForUpstream(upstream) {
    const result = (await axios.get(`/api/comments/upstream/${upstream}`))
      .data as Comment[];
    if (result) {
      return result.map(
        (v) =>
          ({
            ...v,
            created: v.created ? new Date(v.created) : null,
            updated: v.updated ? new Date(v.updated) : null,
          } as Comment)
      );
    }
    return [];
  },
  async countCommentsForUpstream(upstream: string): Promise<number> {
    return (await axios.get(`/api/comments/upstream/${upstream}/count`)).data;
  },
  async edit(comment) {
    return await axios.put(`/api/comments/${comment.id}`, comment);
  },

  async getById(id) {
    const result = (await axios.get(`/api/comments/${id}`)).data;
    return {
      ...result,
      created: result.created ? new Date(result.created) : null,
      updated: result.updated ? new Date(result.updated) : null,
    };
  },

  async addCommentForUpstream(upstream, comment) {
    return (await axios.post(`/api/comments/upstream/${upstream}`, comment))
      .data;
  },

  async delete(comment) {
    return await axios.delete(`/api/comments/${comment.id}`);
  },

  async addAnswer(comment, answer) {
    return (await axios.post(`/api/comments/${comment.id}/answer`, answer))
      .data;
  },
};
